import React from 'react';

import Button from 'Components/Button';
import Modal from 'Components/Modal';
import { COMPLIANCE_LEVEL } from '../annualCompliance';

export default ({ warning, warnings = [], onDismiss }) => {
  const root = document.getElementById('root');
  if (!warning) {
    root.classList.remove('modal-open');
    root.classList.remove('annual-compliance-modal-open');
    return null;
  }

  const isRestricted = warning.level === COMPLIANCE_LEVEL.RESTRICTED;
  root.classList.remove(isRestricted ? 'modal-open' : 'annual-compliance-modal-open');
  const displayedWarnings = isRestricted ? warnings : [warning];
  return (
    <Modal
      isOpen
      className={isRestricted ? 'annual-compliance-modal--restricted' : 'annual-compliance-modal'}
      rootClassName={isRestricted ? 'annual-compliance-modal-open' : 'modal-open'}
    >
      <div className='annual-compliance-modal__warnings'>
        {displayedWarnings.map((displayedWarning, index) => (
          <section className='annual-compliance-modal__warning' key={`${displayedWarning.role}-${displayedWarning.itemType}`}>
            <header className='ect-modal-header'>{displayedWarning.title}</header>
            <div className='ect-modal-body annual-compliance-modal__body'>{displayedWarning.message}</div>
            {index < displayedWarnings.length - 1 && <hr />}
          </section>
        ))}
      </div>
      <footer className='ect-modal-footer'>
        {isRestricted ? (
          <span className='annual-compliance-modal__logout-message'>Use Log out in the header to exit ECT.</span>
        ) : (
          <Button label='OK' buttonClassName='_height_40 _width_160' onClick={onDismiss} />
        )}
      </footer>
    </Modal>
  );
};






// WEBPACK FOOTER //
// ./src/app/Components/AnnualComplianceModal.jsx